import type { DecorationWidgetConfig } from '../../types'

export const widgetConfig: DecorationWidgetConfig = {
  type: 'lead-form',
  name: '线索表单',
  icon: '线',
  group: 'CRM 组件',
  description: '面向客户端的销售线索提交入口。',
  defaultProps: {
    title: '提交合作线索',
    buttonText: '立即提交',
    fields: [
        'name',
        'phone',
        'source'
    ]
}
}
